export default __webpack_public_path__ + "static/media/carpe.eb915ef6.svg";